export default "__VITE_ASSET__C7R$jCcd__"